// extracted by mini-css-extract-plugin
export default {"textButton":"textButton-BoUa_","textButtonRounded":"textButtonRounded-ECgMd","textButtonRectangle":"textButtonRectangle-tg0wX","outlined":"outlined-hTmi5","filled":"filled-sh27F"};